/* eslint-disable import/order */
import { jsmWorkItemServiceRequestRoute } from '@jira/router-routes__jsm-work-item-service-request-routes/src/jsmWorkItemServiceRequestRoute.tsx';
import { jsmWorkItemServiceRequestEntryPoint } from '@jira/spa-apps__jsm-work-item-service-request/src/jsmWorkItemServiceRequestEntryPoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const jsmWorkItemServiceRequestPageEntrypoint = createPageEntryPoint({
	main: jsmWorkItemServiceRequestEntryPoint,
});

export const jsmWorkItemServiceRequestRouteEntry: Route = createEntry(
	jsmWorkItemServiceRequestRoute,
	() => ({
		group: 'servicedesk',

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getNavigationResources()],

		entryPoint: () =>
			fg('jsm_aniv_routing_phase_1')
				? jsmWorkItemServiceRequestPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
